import React from "react";
import * as Icon from "react-bootstrap-icons";
import { useSelector } from "react-redux";
import { getNoticeDay, getNoticeMonth, getNoticeYear } from "../utils/date";
import { Link } from "react-router-dom";
import { getContent } from "../utils/main";

const BildirishItem = ({ notice }) => {
  const lang = useSelector((state) => state.mainSlice.lang);
  const content = useSelector((state) => state.mainSlice.content);
  return (
    <div className="col-12 bildirish-item">
      <Link to={`/notices/${notice.slug}`} className="bra10">
        <div className="row w-100">
          <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12 date-wrapper">
            <span className="day">{getNoticeDay(notice.pub_date)}</span>
            <div className="other-wrapper">
              <span className="month">
                {getNoticeMonth(notice.pub_date, lang)}
              </span>
              <span className="year">{getNoticeYear(notice.pub_date)}</span>
            </div>
          </div>
          <div className="col-lg-10 col-md-10 col-sm-12 col-xs-12 content-wrapper">
            <h5 className="fw-bold">
              <span className="underline-animation-on-hover">
                {lang === "en"
                  ? notice.name_en
                  : lang === "ru"
                  ? notice.name_ru
                  : notice.name_tm}
              </span>{" "}
              {notice.is_new === true ? (
                <span className="new">{getContent(content, "New", lang)}</span>
              ) : (
                ""
              )}{" "}
              <span className="eye">
                <Icon.Eye /> {notice.views}
              </span>
            </h5>
            <p>
              {lang === "en"
                ? notice.short_content_en
                : lang === "ru"
                ? notice.short_content_ru
                : notice.short_content_tm}
            </p>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default BildirishItem;
